import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const GlobalSettingsV2 = React.lazy(async () => ({
    default: (await import('@oc/global-settings/module')).GlobalSettingsModuleV2
}))

export function GlobalSettingsV2Component() {
    return <SuspenseWhileLoading LazyComponent={GlobalSettingsV2} />
}
